import { Avatar, Menu, Text } from '@mantine/core';
import { IconBuildingCommunity } from '@tabler/icons-react';
import { useProfile } from 'init/use-enforce-profile';
import { i18nKeys, useTranslation } from 'locales';
import { useHistory } from 'react-router';
import { COMPANIES_ROUTE, GROUP_OVERVIEW_FEATURE_FLAG } from 'shared/constants';
import { useIsFeatureFlagEnabled } from 'shared/utils/feature-flags';

export const AllCompaniesMenuItem = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { accessibleTenants, group } = useProfile();
  const isGroupOverviewEnabled = useIsFeatureFlagEnabled(GROUP_OVERVIEW_FEATURE_FLAG);

  if (!isGroupOverviewEnabled || group || accessibleTenants.length <= 1) return null;

  return (
    <>
      <Menu.Item
        mb="space1"
        onClick={() => history.push(COMPANIES_ROUTE)}
        leftSection={
          <Avatar radius={6} size={24} color="purple">
            <IconBuildingCommunity stroke="1.5" size={16} />
          </Avatar>
        }
      >
        <Text>{t(i18nKeys.GROUP.NAV_LABEL)}</Text>
      </Menu.Item>
      <Menu.Divider />
    </>
  );
};
